import { useState } from "react";
import {Tooltip, IconButton } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import ButtonEdit from "../../../global/ButtonEdit";
import EnhancedEncryptionOutlinedIcon from '@material-ui/icons/EnhancedEncryptionOutlined';
const columns = [
  { id: "nombre", minWidth: 150, align: "center", label: "Nombre" },
  { id: "Accion", minWidth: 30, align: "center", label: "" },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
});

const TRoles = ({ rows, onEditar = () => {}, onPermiso = () => {} }) => {
  const classes = useStyles();
  // const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const onEdit = (rowItem) => {
    onEditar(rowItem);
  };

  const onPermit = (rowItem) => {
    onPermiso(rowItem);
  };
  // const onChangeSwitch = (SwitchValue, SwitchCheked) =>{
  //   const valEstatus = SwitchCheked ? 1 : 0;
  //   dispatch(bajaProveedorUsuarioAction(SwitchValue, valEstatus)).then((Response) =>{
  //   });
  // }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.Id}>
                    <TableCell align="center">{`${row.Name}`}</TableCell>
                    <TableCell align="center">
                      <ButtonEdit
                        onClick={() => {
                          onEdit(row);
                        }}
                      />
                      <Tooltip title="Permisos">
                        <IconButton
                          aria-label="Permisos"
                          onClick={() =>{onPermit(row)}}
                        >
                          <EnhancedEncryptionOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};
export default TRoles;
